import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SubCollectionForm from '../../../../components/masters/styles/subCollection/SubCollectionForm';
import SubCollectionTable from '../../../../components/masters/styles/subCollection/SubCollectionTable';
import { addSubCollectionAction, updateSubCollectionAction, clearSubCollectionEdit } from '../../../../redux/actions/masters/styles/subCollection/subCollectionAction';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .sub-collection-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .sub-collection-form, .sub-collection-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const SubCollectionPage = () => {
  const dispatch = useDispatch();
  const { editingSubCollection } = useSelector((state) => state.subCollection);
  const users = useSelector(state => state.users.list || []);
  const [formSuccess, setFormSuccess] = useState('');
  const [formError, setFormError] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccess('');
    setFormError('');
  };

  const handleSubmit = async (form) => {
    try {
      if (editingSubCollection && editingSubCollection.sub_collection_id) {
        await dispatch(updateSubCollectionAction({ id: editingSubCollection.sub_collection_id, subCollection: form }));
        setFormError('');
      } else {
        await dispatch(addSubCollectionAction(form));
        setFormError('');
      }
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message;
      if (
        err?.response?.status === 409 ||
        (message && message.toLowerCase().includes('already exists'))
      ) {
        setFormError('');
        throw err;
      }
      setFormError(message || 'An error occurred.');
      throw err;
    }
  };

  const handleCancel = () => {
    dispatch(clearSubCollectionEdit());
    setFormSuccess('');
    setFormError('');
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="sub-collection-flex">
        <div style={tableContainer} className="sub-collection-table">
          <SubCollectionTable onNew={handleFormReset} />
        </div>
        <div style={formContainer} className="sub-collection-form">
          <SubCollectionForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingSubCollection={editingSubCollection}
            onCancel={handleCancel}
            formSuccess={formSuccess}
            formError={formError}
            setFormSuccess={setFormSuccess}
            setFormError={setFormError}
            users={users}
          />
        </div>
      </div>
    </div>
  );
};

export default SubCollectionPage; 